//ref https://github.com/ckeditor/ckeditor5-vue/issues/86

export const paragraphStyleExtender = (editor) => {
    const schema = editor.model.schema;
    const conversion = editor.conversion;
    schema.register("span", {
        inheritAllFrom: "$block",
        allowIn: ["paragraph"],
        allowAttributes: ["id", "class"],
        allowWhere: "$text",

        // The placeholder will act as an inline node:
        isInline: true,

        // The inline widget is self-contained so it cannot be split by the caret and can be selected:
        isObject: true,
    });
    conversion.elementToElement({ model: "span", view: "span" });
    conversion.attributeToAttribute({ model: "class", view: "class" });
    conversion.attributeToAttribute({
        model: { name: "span", key: "id" },
        view: "id",
    });
    schema.extend("$text", {
        allowAttributes: ["spanId", "spanClass"],
    });

    conversion.for("upcast").elementToAttribute({
        view: {
            name: "span",
            attributes: {
                id: /.+/,
            },
        },
        model: {
            key: "spanId",
            value: (viewElement) => viewElement.getAttribute("id"),
        },
    });

    conversion.for("downcast").attributeToElement({
        model: "spanId",
        view: (modelAttributeValue, viewWriter) => {
            return viewWriter.createAttributeElement("span", {
                id: modelAttributeValue,
            });
        },
    });

    // Register custom paragraphClasses (later converted to style) attribute for paragraph element
    schema.extend("paragraph", { allowAttributes: "paragraphClasses" });

    // Add an upacast (view-to-model) converter for style attribute of a paragraph.
    conversion.for("upcast").attributeToAttribute({
        model: {
            name: "paragraph",
            key: "paragraphClasses",
            value: (viewElement) => viewElement.getAttribute("class"),
        },
        view: {
            name: "p",
            key: "class",
            value: /[\s\S]+/,
        },
    });

    // Add an downcast (model-to-view) converter for style attribute of a paragraph.
    conversion.for("downcast").add((dispatcher) => {
        dispatcher.on("attribute:paragraphClasses:paragraph", (evt, data, conversionApi) => {
            const viewElement = conversionApi.mapper.toViewElement(data.item);
            /*conversionApi.writer.setAttribute('style', data.attributeNewValue, viewElement);*/
            conversionApi.writer.setAttribute("class", data.attributeNewValue, viewElement);
        });
    });
};
